import { appKey } from './appStorage';

const KEY = appKey('loginReturn');

// Syvälinkki (esim. sähköpostin linkki tarjoukseen) muistetaan, kun käyttäjä ohjataan kirjautumaan, ja
// kirjautumisen jälkeen palataan siihen. sessionStorage säilyy Microsoft-kirjautumisen uudelleenohjauksen yli.
export function rememberLoginReturn() {
  const hash = window.location.hash;
  if (!hash.startsWith('#/t/')) return;
  try {
    sessionStorage.setItem(KEY, hash.substring(1));
  } catch (e) {
    // sessionStorage ei käytettävissä
  }
}

// Muistettu polku (esim. '/t/<tenant>/quotation/12') tai null; polku käytetään vain kerran.
export function takeLoginReturn() {
  let path = null;
  try {
    path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
  } catch (e) {
    // sessionStorage ei käytettävissä
  }
  return path;
}
